import { render, staticRenderFns } from "./ItemsTypeSwitch.vue?vue&type=template&id=a3fe0b0e&scoped=true&"
import script from "./ItemsTypeSwitch.vue?vue&type=script&lang=ts&"
export * from "./ItemsTypeSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsTypeSwitch.vue?vue&type=style&index=0&id=a3fe0b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fe0b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
